import { CourseResourceTabApi } from "api";
import { ModalHeader } from "components/templates/Modals/ModalHeader";
import { ModalPadding } from "components/templates/Modals/ModalPadding";
import { PaziaModal } from "components/molecules";
import { ResourceTabForm, ResourceTabFormValues } from "./ResourceTabForm";

interface EditCourseResourceTabModalProps {
  onCloseRequest: () => void;
  tab: { name: string; icon: string } | null;
  onSubmit: (data: ResourceTabFormValues) => Promise<void>;
}

export const EditCourseResourceTabModal = ({ onCloseRequest, tab, onSubmit }: EditCourseResourceTabModalProps) => {
  return (
    <PaziaModal
      id="add-resource-tab-modal"
      onCloseRequest={() => {
        onCloseRequest();
      }}
      isOpen={tab != null}
      size="lg"
    >
      {tab != null && (
        <ModalPadding>
          <ModalHeader>Edytuj zakładkę</ModalHeader>
          <ResourceTabForm onSubmit={onSubmit} tab={tab} />
        </ModalPadding>
      )}
    </PaziaModal>
  );
};
